import {
    RECALL_MISSING_TICKET,
    resolveRecallAuth,
    type RecallAuth
} from '../utils/loginAuth';
import { getCookieConfig } from '../utils/passport';

import { API_GET_ACTIVITY, API_JOIN_ACTIVITY } from './interface';

import { httpPost } from '@/services/signRequest';
import { isIOS } from '@/utils/os';
import url from '@/utils/url';

interface Res {
    traceId: string;
    errno: number;
    errmsg: string;
    data:{ [key: string]: any };
}

const commonRequest = async (
    requestUrl: string,
    data?: { [key: string]: any },
    auth?: RecallAuth | null
): Promise<Res> => {
    const pageId = url.get('pageId');
    const loginData = getCookieConfig();
    const ticket = auth?.ticket || loginData?.ticket || '';
    const uid = auth?.uid || loginData?.uid || '';
    const header = {
        'page-id': pageId,
        'country-code': 'MX',
        'business-id': '103',
        'business-scene': 'external_landing_page_v2',
        'didi-fintech-header-content': JSON.stringify({ token: ticket }) as string
    };

    const commonData: { [key: string]: any } = {
        countryCode: 'MX',
        businessId: 103,
        businessScene: 'external_landing_page_v2',
        userType: '1', // 1乘客，2司机
        os: isIOS() ? 'ios' : 'android',
        pageId
    };

    commonData['common'] = {
        location_country: 'MX',
        ticket,
        uid,
    };

    return httpPost(requestUrl, { ...data, ...commonData }, { headers: header }) as Promise<Res>;
};

export const getActivityApi = () => {
    return commonRequest(API_GET_ACTIVITY);
};

export const joinActivityApi = (authOverride?: Partial<RecallAuth> | null) => {
    const auth = resolveRecallAuth(authOverride);

    if (!auth) {
        return Promise.reject({ ...RECALL_MISSING_TICKET });
    }

    return commonRequest(API_JOIN_ACTIVITY, {}, auth);
};
